import { render, staticRenderFns } from "./ListingRelated.vue?vue&type=template&id=2db5604f&"
import script from "./ListingRelated.vue?vue&type=script&lang=js&"
export * from "./ListingRelated.vue?vue&type=script&lang=js&"
import style0 from "./ListingRelated.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports